(function () {
  var path = window.location.pathname || "/";
  var match = path.match(/^\/([a-z]{2})(\/|$)/i);
  if (!match) return;

  var locale = match[1].toLowerCase();
  var prefix = "/" + locale;

  var localizeIfStartsWith = [
    "/collections/",
    "/pages/",
    "/products/",
    "/blogs/",
    "/policies/",
    "/search"
  ];

  document.querySelectorAll('a[href^="/"]').forEach(function (a) {
    var href = a.getAttribute("href");
    if (!href) return;

    if (href.startsWith(prefix + "/") || href === prefix) return;
    if (href.startsWith("/cdn/") || href.startsWith("/apps/")) return;
    if (href.startsWith("/cart") || href.startsWith("/checkout")) return;

    var should = localizeIfStartsWith.some(function (start) {
      return href === start || href.startsWith(start);
    });
    if (!should) return;

    a.setAttribute("href", prefix + href);
  });
})();